export const PROFILE_EDIT_RUBROS_QUERY = "rubros";

export function isAllowedJobboardReturnPath(path: string | null | undefined): boolean {
  if (!path || !path.startsWith("/") || path.startsWith("//")) return false;
  return path === "/bolsa-trabajo" || path.startsWith("/bolsa-trabajo/");
}

export function buildProfileEditRubrosUrl(
  userId: string | number,
  returnTo?: string | null
): string {
  const base = `/perfil/${userId}`;
  const search = new URLSearchParams();
  search.set("edit", PROFILE_EDIT_RUBROS_QUERY);
  if (returnTo && isAllowedJobboardReturnPath(returnTo)) {
    search.set("returnTo", returnTo);
  }
  return `${base}?${search.toString()}`;
}

export function stripProfileEditQueryParams(search: string): string {
  const params = new URLSearchParams(search);
  params.delete("edit");
  params.delete("returnTo");
  const query = params.toString();
  return query ? `?${query}` : "";
}
